import caseIcon from '../../../../assets/images/reskin-images/icon--case.svg';
import caseIconActive from '../../../../assets/images/reskin-images/icon--case-active.svg';
import userCircle from '../../../../assets/images/reskin-images/icon--user-circle.svg';
import userCircleActive from '../../../../assets/images/reskin-images/icon--user-circle-active.svg';
import smartphone from '../../../../assets/images/reskin-images/icon--smartphone.svg';
import smartPhoneActive from '../../../../assets/images/reskin-images/icon--smartphone-active.svg';
import shieldKeyHole from '../../../../assets/images/reskin-images/icon--shield-keyhole.svg';
import shieldKeyHoleActive from '../../../../assets/images/reskin-images/icon--shield-keyhole-active.svg';

const icons = {
  caseIcon,
  caseIconActive,
  userCircle,
  userCircleActive,
  smartphone,
  smartPhoneActive,
  shieldKeyHole,
  shieldKeyHoleActive,
};

export default icons;
